export default class LimeApi {
    static MemberGateway: string = 'member_gateway_api';
    static Appointment: string = 'appointment_api';
}